import * as React from 'react'

const SvgListNumberedIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 13.75h8.75V15H10v-1.25zM10 5h8.75v1.25H10V5zM5 7.5v-5H3.75v.625H2.5v1.25h1.25V7.5H2.5v1.25h3.75V7.5H5zm1.25 10H2.5V15c0-.69.56-1.25 1.25-1.25H5V12.5H2.5v-1.25H5c.69 0 1.25.56 1.25 1.25v1.25C6.25 14.44 5.69 15 5 15H3.75v1.25h2.5v1.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgListNumberedIcon
